// OWASP A02 — only the bearer token lives in localStorage. No PII, no patient IDs.
export const TOKEN_KEY = 'auth.token';

export const tokenStorage = {
  read(): string | null {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },
  write(token: string) {
    try {
      localStorage.setItem(TOKEN_KEY, token);
    } catch {
      // Quota / private mode — fall through silently.
    }
  },
  clear() {
    try {
      localStorage.removeItem(TOKEN_KEY);
    } catch {
      // ignore
    }
  },
};
